// @flow
import React, {PureComponent} from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import config from '../../config';
import {getRoamingGroupCountries} from '../../lib/country-utils.js';
import InternationalButton from './components/InternationalButton';
import * as Navigation from '../../lib/navigation.js';

class International extends PureComponent<Props> {
  styles = getStyles();
  roamingLikeHomeCountries = getRoamingGroupCountries(
    config.iddCountries,
    'ROAM_LIKE_HOME',
  );
  roamingLikeHomeCountriesList = this.roamingLikeHomeCountries
    .map(country => country.name)
    .join(', ');

  goToSelectIddCountries = () => Navigation.navigate('selectIDDCountry');
  goToSelectTravelCountries = () => Navigation.navigate('selectTravelCountry');
  goToSelectRoamingCountries = () =>
    Navigation.navigate('selectRoamingCountry');
  goToRoamingLikeHome = () => {
    this.props.setRoamingCountry(this.roamingLikeHomeCountries[0]);
    Navigation.navigate('roamingOffer');
  };
  goToPremium = () => Navigation.navigate('myWalletForPremium');

  render() {
    const styles = this.styles;
    return (
      <ScrollView style={styles.container}>
        <InternationalButton
          color={theme.internationalIddButtonColor}
          title={I18n.t('International.idd')}
          onPress={this.goToSelectIddCountries}
          iconName="international"
          iconSize={70}
        />
        {config.canBuyTravel && (
          <InternationalButton
            color={theme.internationalTravelButtonColor}
            title={I18n.t('International.travel')}
            onPress={this.goToSelectTravelCountries}
            iconName="phone-plane"
            iconSize={70}
          />
        )}
        {config.canBuyRoamLikeHome && (
          <InternationalButton
            color={theme.internationalRoamLikeHomeButtonColor}
            title={I18n.t('International.roamLikeHome')}
            onPress={this.goToRoamingLikeHome}
            iconName="phone-house-world"
            iconSize={80}
          />
        )}
        {config.canBuyPremium && (
          <InternationalButton
            color={theme.internationalPremiumButtonColor}
            title={I18n.t('International.premium')}
            onPress={this.goToPremium}
            iconName="euro"
            iconSize={70}
          />
        )}
        {config.canBuyRoamingPackage && (
          <InternationalButton
            color={theme.internationalRoamingButtonColor}
            title={I18n.t('International.roaming')}
            onPress={this.goToSelectRoamingCountries}
            iconName="phone-plane"
            iconSize={70}
          />
        )}
      </ScrollView>
    );
  }
}

function getStyles() {
  return StyleSheet.create({
    container: {
      paddingHorizontal: 8,
      marginVertical: 8,
    },
  });
}

type Props = {
  setRoamingCountry: Function,
};

export default International;
